export default __webpack_public_path__ + "static/blob5-e923c8ba982d1e12ca58ef74adeeeb83.svg";